// ネイティブdialogもBootstrapモーダルと同様に外クリックでキャンセルする。
// 内側から外側へのドラッグでは閉じない。
let pressedOutside: HTMLDialogElement | null = null;

function outsideDialog(event: MouseEvent): HTMLDialogElement | null {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return null;
    const rect = dialog.getBoundingClientRect();
    return event.clientX < rect.left || event.clientX > rect.right ||
        event.clientY < rect.top || event.clientY > rect.bottom ? dialog : null;
}

document.addEventListener('pointerdown', event => {
    pressedOutside = event.button === 0 ? outsideDialog(event) : null;
}, true);
document.addEventListener('pointercancel', () => { pressedOutside = null; }, true);
document.addEventListener('click', event => {
    const dialog = outsideDialog(event);
    const dismiss = dialog && dialog === pressedOutside;
    pressedOutside = null;
    if (!dismiss) return;
    event.preventDefault();
    event.stopPropagation();
    if (dialog.dispatchEvent(new Event('cancel', { cancelable: true }))) dialog.close();
}, true);
